import { ofType } from 'redux-observable';
import { Observable, of, merge } from 'rxjs';
import { tap, take } from 'rxjs/operators';

import { mixer } from './mixer';
import {
   SET_LOOP_MODE_PLAYING,
   STOP_PLAYING,
   TOGGLE_LOOP_MODE_PLAYING,
} from './actions';
import { audioContext } from '../../webAudio/audioContext';
import {
   CLEAR_ACTIVE_INTERFACE,
   SET_ACTIVE_INTERFACE,
} from '../../app/actions';
import { createLoopNode } from '../../webAudio/createLoopNode';

const playLoop = (action$, state$) =>
   Observable.create((observer) => {
      const loopSet = new Set();

      if (process.env.NODE_ENV === 'development') {
         window.loopSet = loopSet;
      }
      const stopLoops = () => {
         loopSet.forEach((node) => node.stop());
      };

      const playLoops = () => {
         state$.value.activeInterface.instrumentRack.forEach(
            ({ source }, instrumentIndex) => {
               const time = audioContext.currentTime;

               const sound =
                  state$.value.activeInterface.loops.cache[
                     state$.value.activeInterface.loops.currentLoop
                  ]?.samples?.[source];

               // prevent error when they play before has loaded
               // Also does not play anything for aux tracks
               if (!sound) {
                  // could show warning here that sounds haven't loaded?
                  return;
               }

               const synthNode = createLoopNode(sound);
               synthNode.connect(mixer.tracks[instrumentIndex].pregain);

               synthNode.start(time);
               loopSet.add(synthNode);
               synthNode.onended = () => loopSet.delete(synthNode);
            }
         );
      };

      const loopPlayer = merge(
         of({}).pipe(tap(playLoops)),
         action$.pipe(
            ofType(
               TOGGLE_LOOP_MODE_PLAYING,
               SET_LOOP_MODE_PLAYING,
               STOP_PLAYING,
               CLEAR_ACTIVE_INTERFACE,
               SET_ACTIVE_INTERFACE
            ),
            take(1),
            tap(stopLoops)
         )
      );

      return loopPlayer.subscribe({
         complete: () => {
            observer.complete();
         },
      });
   });

export { playLoop };
